import React, { FC } from 'react';
import { Title } from '../../developers/page-components/Title';
import { FormInput } from '../FormInput';
import { BUSINESS_METRICS_INPUTS } from '../../../constants/merchant/business-inputs';
import { useTranslation } from 'react-i18next';

interface Props {
  formik: any;
  isEditMode: boolean;
}

export const MerchantsBusinessMetrics: FC<Props> = (props) => {

  const { formik, isEditMode } = props;

  const { t } = useTranslation();

  const METRICS_INPUTS = BUSINESS_METRICS_INPUTS({ t });

	return (
		<>
      <div className="separator pt-5 mb-5"/>
      <Title
        title={t('SELF_ONBOARDING.SECTION_TITLE.VOLUME_ESTIMATES')}
        additionalClass="fs-2"
      />

      <div className="separator pt-5 mb-5"/>

      <div className="row">
        {
          METRICS_INPUTS.map(item => {
            return (
              <FormInput
                {...item}
                key={item.key}
                formik={formik}
                isEditMode={isEditMode}
              />
            );
          })
        }
      </div>
    </>
	);
};
